export default {
  SET_LISTA_UNIDADE_MEDIDA(state, payload) {
    state.listaUnidadeMedidas = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  SET_UNIDADES_MEDIDA(state, payload) {
    state.unidadesMedida = payload;
  },
};
